import * as React from "react";
import { Grid, FormControl, MenuItem, Select, Typography } from "@mui/material";
import DownArrow from "../DownArrow";
import DialplanNode from "./DialplanNode";
import TtsAnnounce from "./TtsAnnounce";
import { useDialplanNodeContext } from "./DialplanNode";
import { useDialplanEditorContext } from "./DialplanEditorContext";

const VOICE_OPTIONS = [
  { value: 'ISABELLA', label: '👩 Isabella' },
  { value: 'DIEGO', label: '👨 Diego' },
  { value: 'ANNA', label: '👩 Anna' },
  { value: 'GIOVANNI', label: '👨 Giovanni' }
];

function SmartGreeting() {
  const { node, setNode } = useDialplanNodeContext();
  const { isEditMode } = useDialplanEditorContext();

  const handleVoiceChange = (event) => {
    const voiceName = event.target.value;
    setNode({
      ...node,
      voiceName: voiceName
    });
  };

  const currentVoice = node?.voiceName || 'ISABELLA';

  return (
    <>
      <Grid container direction={"column"}>
        <Grid item xs={12}>
          <div style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
          }}>
            <Typography variant="h6" align="left">
              🌅 Saluto intelligente
            </Typography>
          </div>
        </Grid>
        
        <Grid item xs={12} sx={{ mt: 2 }}>
          <Typography variant="body1" color="text.secondary">
            Riproduce automaticamente il saluto appropriato in base all'orario:
          </Typography>
          <Typography variant="body2" sx={{ mt: 1, ml: 2 }}>
            • <strong>Buongiorno</strong> dalle 5:00 alle 12:00<br/>
            • <strong>Buon pomeriggio</strong> dalle 12:00 alle 18:00<br/>
            • <strong>Buona sera</strong> dalle 18:00 alle 5:00
          </Typography>
        </Grid>

        { isEditMode && (
        <Grid item xs={12} sx={{ mt: 3 }}>
          <FormControl fullWidth>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>
              Voce per il saluto
            </Typography>
            <Select
              value={currentVoice}
              onChange={handleVoiceChange}
            >
              {VOICE_OPTIONS.map(option => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        )}
      </Grid>
      
      <DownArrow/>
      <DialplanNode prop="next"/>
    </>
  );
}

SmartGreeting.description = "Riproduce automaticamente il saluto appropriato (Buongiorno/Buon pomeriggio/Buona sera) in base all'orario";
SmartGreeting.title = "Saluto intelligente";
SmartGreeting.default = {
  type: "SMART_GREETING",
  voiceName: "ISABELLA",
  next: TtsAnnounce.default,
};
SmartGreeting.isAdvanced = false;

export default SmartGreeting; 